<template>
  <component
    :is="icon"
    class="dn-icon"
  />
</template>
<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
const props = defineProps({
  /**
   * Svg src
   * @param {String} value = svgUrl
   */
  name: {
    type: String,
    required: false,
    default: 'logo'
  }
});
const icon = computed(() => {
  const iconList = import.meta.glob('@/assets/**/logo/**/*.svg');
  return iconList[`/assets/${useRuntimeConfig().public?.name}/logo/${props.name}.svg`]
    ? defineAsyncComponent(async () => {
      try {
        return await iconList[`/assets/${useRuntimeConfig()?.public?.name}/logo/${props.name}.svg`]();
      } catch (e) {
        console.warn(`Icon ${props.name} is not available`, e);
      }
    })
    : null;
});
</script>
<style lang="scss">
.dn-icon {
  padding: 0;
  margin: 0;
}
</style>
